import React from "react";
import { Check, PenTool, Factory, Truck, Hammer } from "lucide-react";

export const PROJECT_STAGES = [
  { key: "design", label: "Design", icon: PenTool },
  { key: "production", label: "Production", icon: Factory },
  { key: "ready_for_delivery", label: "Ready For Delivery", icon: Truck },
  { key: "installation", label: "Installation", icon: Hammer },
];

// Horizontal stepper: Design → Production → Ready For Delivery → Installation
export const StageTracker = ({ stage, completed, onSelect, compact }) => {
  const idx = Math.max(PROJECT_STAGES.findIndex(s => s.key === stage), 0);
  return (
    <div className="flex items-start w-full" data-testid="stage-tracker">
      {PROJECT_STAGES.map((s, i) => {
        const done = completed || i < idx;
        const active = !completed && i === idx;
        const Icon = s.icon;
        return (
          <React.Fragment key={s.key}>
            <button type="button" disabled={!onSelect} onClick={() => onSelect?.(s.key)} className={`flex flex-col items-center flex-1 min-w-0 group ${onSelect ? "cursor-pointer" : "cursor-default"}`} data-testid={`stage-${s.key}`}>
              <div className={`rounded-full flex items-center justify-center transition-colors ${compact ? "w-8 h-8" : "w-11 h-11"} ${done ? "bg-green-600 text-white" : active ? "bg-indigo-600 text-white ring-4 ring-indigo-100" : "bg-slate-200 text-slate-500 group-hover:bg-slate-300"}`}>
                {done ? <Check className={compact ? "w-4 h-4" : "w-5 h-5"} /> : <Icon className={compact ? "w-4 h-4" : "w-5 h-5"} />}
              </div>
              <span className={`mt-2 text-center leading-tight ${compact ? "text-[11px]" : "text-xs sm:text-sm"} ${active ? "font-semibold text-indigo-700" : done ? "text-green-700" : "text-slate-500"}`}>{s.label}</span>
              {active && !compact && <span className="text-[10px] uppercase tracking-wide text-indigo-500 mt-0.5">In progress</span>}
            </button>
            {i < PROJECT_STAGES.length - 1 && <div className={`h-0.5 flex-1 mx-1 ${compact ? "mt-4" : "mt-5"} ${i < idx || completed ? "bg-green-500" : "bg-slate-200"}`} />}
          </React.Fragment>
        );
      })}
    </div>
  );
};
